import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  IonActionSheet,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import useTituloPagina from "../../hooks/tituloPagina";
import { Typography } from "@mui/material";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  ListItem,
} from "@mui/joy";
import "./EstudiosPaciente.css";
import VisibilityIcon from "@mui/icons-material/Visibility"; // Icono de "ojo" para previsualizar
import DownloadIcon from "@mui/icons-material/Download";
import Tooltip from "@mui/material/Tooltip";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function EstudiosPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
  });
  const [abrirModal, setAbrirModal] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });

  //? Agrupar estudios por tipo
  const agruparEstudiosPorTipo = (estudios) => {
    const estudiosAgrupados = {};

    estudios.forEach((estudio) => {
      const tipoEstudio = estudio.carpeta;
      if (!estudiosAgrupados[tipoEstudio]) {
        estudiosAgrupados[tipoEstudio] = [];
      }
      estudiosAgrupados[tipoEstudio].push(estudio);
    });

    return estudiosAgrupados;
  };
  const estudiosAgrupados = agruparEstudiosPorTipo(listadoEstudios);

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const getTipoArchivo = (nombreArchivo) => {
    let partes = nombreArchivo.split(".");
    let tipo = partes.at(-1);
    if (tipo && ["pdf", "jpg", "bmp"].includes(tipo)) return tipo;
    else return null;
  };

  const traerEstudiosPaciente = async (paciente) => {
    const carpetasValidas = [1, 2, 3, 4, 5, 6, 7, 8];
    let estudios = [];
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };
    let urlAxioPP = localStorage.getItem("urlAxioPP");
    try {
      const response = await Promise.all(
        carpetasValidas.map((carpeta) =>
          axios
            .get(
              `${urlAxioPP}EstudiosImagenes/TraerNombresArchivos?documentoNro=${paciente.documentoNro}&carpeta=${carpeta}`,
              config
            )
            .then((res) => {
              if (res.data.length !== 0) {
                return {
                  data: res.data.map((estudio) => ({ ...estudio, carpeta })),
                };
              } else {
                return { data: [] };
              }
            })
            .catch(() => {
              return { data: [] };
            })
        )
      );

      if (response.length !== 0) {
        response.forEach((carpeta) => {
          if (carpeta.data.length !== 0) {
            carpeta.data.forEach((estudio) => {
              estudios.push(estudio);
            });
          }
        });
      }

      estudios = estudios.map((estudio, i) => {
        let nombre = estudio.nombre;
        nombre = nombre.replace(`${paciente.documentoNro}`, "");
        nombre = nombre.replace(`.${getTipoArchivo(estudio.nombre)}`, "");
        let fecha = dayjs(estudio.fechaModificacion);
        if (fecha.isValid()) {
          return {
            ...estudio,
            codigo: i,
            fecha: fecha.format("DD/MM/YYYY"),
            text: nombre,
            formato: getTipoArchivo(estudio.nombre),
          };
        } else {
          return {
            ...estudio,
            codigo: i,
            fecha: "No disponible",
            text: nombre,
          };
        }
      });
      setListadoEstudios(estudios);
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const BuscarEstudio = async (estudio, pdfDoc, pdfUrl, returnBlob) => {
    let urlAxioPP = localStorage.getItem("urlAxioPP");

    try {
      const response = await axios.request({
        url: `${urlAxioPP}EstudiosImagenes/DescargarGaImagenes?documentoNro=${usuario.documentoNro}&nombreArchivo=${estudio.nombre}&formato=${estudio.formato}&carpeta=${estudio.carpeta}`,
        method: "GET",
        responseType: "blob",
        auth: `Bearer ${usuario.token}`,
      });

      if (response.data.size > 0) {
        if ((pdfDoc && !pdfUrl) || returnBlob) {
          let file = new Blob([response.data]);

          //? en caso solo nos interese el blob(cuando descargamos el conjunto)
          if (returnBlob) return file;

          let fileURL = URL.createObjectURL(file);

          // create <a> element dynamically
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;

          // suggest a name for the downloaded file
          fileLink.download = `${estudio.nombre.replace(
            `.${getTipoArchivo(estudio.nombre)}`,
            ""
          )}-${dayjs(estudio.fechaModificacion).format("DD/MM/YYYY")}.${
            estudio.formato
          }`;

          // simulate click
          fileLink.click();
          // fileDownload(pdfBlob, `${estudio.estudioNom}-${dayjs(estudio.fecha).format("DD/MM/YYYY")}.pdf`);
        } else {
          const pdfURL = URL.createObjectURL(response.data);
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.nombre.replace(
                `.${getTipoArchivo(estudio.nombre)}`,
                ""
              ),
              tipo: getTipoArchivo(estudio.nombre),
              doc: pdfURL,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const DescargarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, true, false);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, false, true);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerEstudiosPaciente(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setUsuario(sesion);
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  //cosas para el modal
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const formatearFechaHora = (nombreEstudio) => {
    let partes = nombreEstudio.split("_"); // Dividir el nombre por "_"
    if (partes.length >= 3) {
      const fechaCruda = partes[1]; // Obtener la fecha (06032025)

      // Extraer día, mes y año manualmente
      const dia = fechaCruda.substring(0, 2); // Primeros 2 dígitos (día)
      const mes = fechaCruda.substring(2, 4); // Siguientes 2 dígitos (mes)
      const anio = fechaCruda.substring(4, 8); // Últimos 4 dígitos (año)

      // Crear una fecha válida para dayjs
      const fechaFormateada = dayjs(`${anio}-${mes}-${dia}`).format(
        "DD/MM/YYYY"
      );

      console.log("Fecha formateada:", fechaFormateada); // Verificar la fecha formateada
      //console.log("Hora formateada:", horaFormateada); // Verificar la hora formateada

      return `${fechaFormateada}`; // Devolver "DD/MM/YYYY HH:mm"
    } else {
      partes = nombreEstudio.split("-"); // Dividir el nombre por "-"
      if (partes.length >= 3) {
        const fechaCruda = partes[1]; // Obtener la fecha (06032025)

        // Extraer día, mes y año manualmente
        const dia = fechaCruda.substring(0, 2); // Primeros 2 dígitos (día)
        const mes = fechaCruda.substring(2, 4); // Siguientes 2 dígitos (mes)
        const anio = fechaCruda.substring(4, 8); // Últimos 4 dígitos (año)

        // Crear una fecha válida para dayjs
        const fechaFormateada = dayjs(`${anio}-${mes}-${dia}`).format(
          "DD/MM/YYYY"
        );

        console.log("Fecha formateada:", fechaFormateada); // Verificar la fecha formateada
        //console.log("Hora formateada:", horaFormateada); // Verificar la hora formateada

        return `${fechaFormateada}`; // Devolver "DD/MM/YYYY HH:mm"
      }
    }
    return "Fecha no disponible"; // Si no se puede extraer la fecha
  };

  return (
    <>
      {listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene estudios registrados aun</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {/* Tabla */}
          <IonList lines="none">
            <IonGrid className="tabla">
              <IonItem className="fila cabecera">
                <IonCol className="celda cabecera nombre">
                  <p>Nombre</p>
                </IonCol>
                <IonCol className="celda cabecera fecha">
                  <p>Fecha</p>
                </IonCol>
                <IonCol className="celda cabecera acciones">
                  <p>Acciones</p>
                </IonCol>
              </IonItem>

              {/* Agrupar estudios por tipo (carpeta) */}
              {Object.entries(
                listadoEstudios.reduce((acc, estudio) => {
                  const tipo = estudio.carpeta;
                  if (!acc[tipo]) {
                    acc[tipo] = [];
                  }
                  acc[tipo].push(estudio);
                  return acc;
                }, {})
              ).map(([tipo, estudios]) => (
                <AccordionGroup key={tipo} variant="outlined" transition="0.2s">
                  <Accordion>
                    <AccordionSummary style={{ margin: 0 }}>
                      {tipo === "1"
                        ? "Colposcopia"
                        : tipo === "2"
                        ? "PAP"
                        : tipo === "3"
                        ? "Ecografía"
                        : tipo === "4"
                        ? "Informes Laboratorio"
                        : tipo === "5"
                        ? "Embriologia"
                        : tipo === "6"
                        ? "Estudios Genéticos"
                        : tipo === "7"
                        ? "Cardiovascular"
                        : tipo === "8"
                        ? "Histeroscopia"
                        : "Otro Estudio"}
                    </AccordionSummary>

                    <AccordionDetails>
                      {estudios.map((estudio) => (
                        <ListItem key={estudio.codigo}>
                          <IonCol className="celda">
                            <p
                              style={{
                                margin: 0,
                                textAlign: "center",
                                paddingLeft: 80,
                              }}
                            >
                              {formatearFechaHora(estudio.text)}
                            </p>
                          </IonCol>

                          <StyledButton
                            slot="end"
                            fill="clear"
                            expand="full"
                            onClick={() => VisualizarPdf(estudio)}
                          >
                            <Tooltip
                              title={
                                <Typography sx={{ fontSize: "16px" }}>
                                  Visualizar
                                </Typography>
                              }
                              arrow
                            >
                              <VisibilityIcon sx={{ color: "#1a336e" }} />
                            </Tooltip>
                          </StyledButton>

                          <StyledButton
                            slot="end"
                            fill="clear"
                            expand="full"
                            onClick={() => DescargarPdf(estudio)}
                          >
                            <Tooltip
                              title={
                                <Typography sx={{ fontSize: "16px" }}>
                                  Descargar
                                </Typography>
                              }
                              arrow
                            >
                              <DownloadIcon sx={{ color: "#1a336e" }} />
                            </Tooltip>
                          </StyledButton>
                        </ListItem>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </AccordionGroup>
              ))}
            </IonGrid>
          </IonList>

          {/* Modal para previsualizar PDF */}
          <IonActionSheet
            header={`${estudioPdf.nombre}`}
            buttons={[
              {
                text: "Cancelar",
                role: "cancel",
                data: {
                  action: "cancel",
                },
              },
            ]}
            onDidDismiss={abrirCerrarModal}
          >
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document
                  file={estudioPdf.doc}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonActionSheet>

          {/* Modal para previsualizar PDF (alternativo)*/}
          <IonModal isOpen={abrirModal} backdropDismiss={false} expand="block">
            <IonHeader>
              <IonToolbar>
                <IonTitle>{`${estudioPdf.nombre} - ${estudioPdf.fecha}`}</IonTitle>
                <StyledButton
                  slot="end"
                  strong={true}
                  onClick={() => abrirCerrarModal()}
                  fill="clear"
                  className="amarillo-sol-text"
                >
                  Cerrar
                </StyledButton>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document
                  file={estudioPdf.doc}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonModal>

          <CustomToast
            openToast={toast.open}
            onDidDismiss={() => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
